import type React from "react";
import styles from "./TutorialModal.module.scss";

interface TutorialModalProps {
  onStart: () => void;
  onLater: () => void;
  onSkip: () => void;
}

const TutorialModal: React.FC<TutorialModalProps> = ({ onStart, onLater, onSkip }) => {
  return (
    <div className={styles["overlay"]}>
      <div className={styles["modal"]}>
        <div className={styles["logo"]}>
          <img src="/reqxignlogo.ico" alt="REQXIGN" />
        </div>
        <h2 className={styles["title"]}>REQXIGNへようこそ！</h2>
        <p className={styles["description"]}>
          サンプルプロジェクトを使って、REQXIGNの基本的な使い方を学びましょう。
          議事録のアップロードからシステム概要書の生成まで、 ステップ形式でご案内します。
        </p>
        <ul className={styles["highlights"]}>
          <li>議事録 → システム概要書の生成フローを体験</li>
          <li>ナレッジとAIチャットの活用方法を確認</li>
          <li>実際のUIで操作感をつかみながら学習</li>
        </ul>
        <div className={styles["buttons"]}>
          <button className={styles["primaryButton"]} onClick={onStart}>
            サンプルプロジェクトに入ってみる
          </button>
          <button className={styles["secondaryButton"]} onClick={onLater}>
            あとで
          </button>
          <button className={styles["skipButton"]} onClick={onSkip}>
            今後表示しない
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutorialModal;
